import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, ShieldX } from 'lucide-react';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading, isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-rms-dark-900 flex flex-col items-center justify-center gap-4">
        <Loader2 className="w-12 h-12 text-wrg-blue-500 animate-spin" />
        <p className="text-slate-400 text-lg">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-rms-dark-900 flex flex-col items-center justify-center gap-4 text-center px-4">
        <ShieldX className="w-16 h-16 text-red-500" />
        <h1 className="text-2xl font-bold text-slate-100">Access Denied</h1>
        <p className="text-slate-400">You don't have permission to access this page.</p>
        <p className="text-slate-500 text-sm">Administrator privileges are required.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
